import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { CircularProgress, Dialog, DialogContent, DialogTitle } from "@mui/material"
import { getIsReusableStepRebuildInProgressSelector } from "../../../../../reducers/Steps/steps"

// asks the browser to confirm leaving the page
const confirmLeaving = (event) => {
    event.preventDefault()
    event.returnValue = ""
}

/**
 * KFC-565: blocks the page while the recipes calling a reusable step are updated, so that the user
 * does not leave before the result (snackbar, recipes to update manually) is shown.
 */
const ReusableStepRebuildProgressDialog = () => {
    const inProgress = useSelector(getIsReusableStepRebuildInProgressSelector)

    useEffect(() => {
        if (!inProgress) return
        window.addEventListener("beforeunload", confirmLeaving)
        return () => window.removeEventListener("beforeunload", confirmLeaving)
    }, [inProgress])

    if (!inProgress) return null

    return (
        <Dialog open disableEscapeKeyDown maxWidth="xs" fullWidth aria-labelledby="reusable-step-rebuild-progress-title">
            <DialogTitle id="reusable-step-rebuild-progress-title">Mise à jour des recettes en cours</DialogTitle>
            <DialogContent className="flexCenter">
                <CircularProgress />
            </DialogContent>
        </Dialog>
    )
}

export default ReusableStepRebuildProgressDialog
